import { FlameIcon, PackageOpenIcon, UsersIcon, TrendingUpIcon, RocketIcon } from 'lucide-react';

export const bonuses = [
  {
    number: '01',
    title: 'The Warm-Up & Mobility Vault',
    coverTitle: 'Warm-Up & Mobility Vault',
    description:
      '30 timed routines organized by session focus, with exercise instructions, coaching cues, and easier options.',
    cover: 'https://cdn.magicpatterns.com/uploads/wQmKSa3JVVpENUkimviWRY/img_hy_ingle_1.webp',
    icon: FlameIcon,
    tone: 'cream' as const,
  },
  {
    number: '02',
    title: 'The Limited-Equipment Workout Pack',
    coverTitle: 'Limited-Equipment Workouts',
    description:
      '20 complete alternative sessions, with a matching guide to help you replace suitable main-program workouts when equipment is unavailable.',
    cover: 'https://cdn.magicpatterns.com/uploads/tx3c2SJPhE4XfqJyHN73ap/imag_hyrox_2.webp',
    icon: PackageOpenIcon,
    tone: 'mist' as const,
  },
  {
    number: '03',
    title: 'The Mixed-Level Class Toolkit',
    coverTitle: 'Mixed-Level Class Toolkit',
    description:
      'Exercise adaptations, workload options, and printable station cards to organize participants with different abilities.',
    cover: 'https://cdn.magicpatterns.com/uploads/tMwtoavgasUKoxj84U46Ay/img_hyros_3.webp',
    icon: UsersIcon,
    tone: 'cream' as const,
  },
  {
    number: '04',
    title: 'The Athlete Progress Tracker',
    coverTitle: 'Athlete Progress Tracker',
    description:
      'Ready-to-use assessments, attendance sheets, workout logs, benchmark comparisons, and monthly progress reports.',
    cover: 'https://cdn.magicpatterns.com/uploads/pgTngcWFvM6twAc3pybi5N/img_hyrox_4.webp',
    icon: TrendingUpIcon,
    tone: 'mist' as const,
  },
  {
    number: '05',
    title: 'The First-Class Launch Kit',
    coverTitle: 'First-Class Launch Kit',
    description:
      'A 14-day launch calendar, promotional copy, invitation messages, an introductory class plan, and follow-up templates.',
    cover: 'https://cdn.magicpatterns.com/uploads/fZEN3rLjXZk5E98bNjKwQL/img_hyrox_5.webp',
    icon: RocketIcon,
    tone: 'cream' as const,
  },
];
